export const environment = {
  production: false,
  InstrumentationKey: "9defe33b-ecca-4148-8b46-d46bd93fe7cf",
  environment: "UAT",
  version: "18.0.0",
  supportEmail: "TGI_LabPortSupport@eurofins-usclinical.freshdesk.com",
  customerPortalServiceUrl: "https://g123001tgiwapu002-g4d2abb8bue9h0e3.a01.azurefd.net/api/",
  IdentityServiceUrl: "https://g123001tgiwapu002-g4d2abb8bue9h0e3.a01.azurefd.net/idm/api/",
  NotificationServiceUrl: "https://aeus2tgiwapu010.azurewebsites.net/",
  cdnImageServiceUrl: "https://aeus2tgisau001-gfbdfbc8gcecgugu.a01.azurefd.net/images/",
  gridRefreshTimeout: "300000",
  timeOut: "30",
  smartyStreetWesiteKey: "108175047762258622",
  report_logo: "NTD_logo.png",
  idmBasicAuthToken: "NjlFQzNCNjQtRkY2RC00QjRELTk0RTMtMzMyNTFBQ0I5RTUx",
  userLockoutAfterMinutes: "1",
  userLockoutAfterAttempts: "2",
  PwdLifeTime: "365",
  FirstReminder: "-15",
  getCountryList: ["USA"],
  getProjectToDisable: [],
  maxReportsToMerge: "25",
  azureBasicAuthToken: "2A5A4A4F-A769-430E-B6D9-5D6BE580B264",
  timerDuration: "30",
  drawInNextNDays: "30",
  soExpiringInNextNDays: "30"
};
